// src/App.js
import React, { useEffect, useState, useCallback } from 'react';
import Toolbar from './components/Toolbar';
import GraphContainer from './components/GraphContainer';
import Sidebar from './components/Sidebar';
import BarChartContainer from './components/BarChartContainer';
import Loader from './components/Loader';
import FinanceForecastApi from './http/api';
import { FINANICAL_LEVERS } from './constants/general';
import Toast from './components/Toast';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const initialData = [
  { name: 'Jan', actual: 4000, predicted: null },
  { name: 'Feb', actual: 3534, predicted: 3500 },
  { name: 'Mar', actual: 2000, predicted: 2500 },
];


const initialEntities = [
  { name: FINANICAL_LEVERS.TARGET, value: 20, min: 0, max: 100, unit: "%", frozen: false, keyToAccessValue: 'Revenue', displayRange: false, payloadKey: 'targetF' },
  { name: FINANICAL_LEVERS.SALES, value: 19.16, unit: "%", min: 0, max: 100, frozen: false, keyToAccessValue: 'initialSalesP', displayRange: false, payloadKey: 'Sales' },
  { name: FINANICAL_LEVERS.COGS, value: 18.77, unit: "%", min: 0, max: 100, frozen: false, keyToAccessValue: 'initialCOGSRef', displayRange: true, payloadKey: 'COGS' },
  { name: FINANICAL_LEVERS.DISCOUNT, value: 3.0, unit: "%", min: 0, max: 50, frozen: false, keyToAccessValue: 'Discount', displayRange: true, payloadKey: 'disProd1' },
  { name: FINANICAL_LEVERS.ADVERTISEMENT_COST, value: 50000, min: 0, max: 1000000, unit: "$", frozen: false, keyToAccessValue: 'AdvCost', displayRange: true, payloadKey: 'advertisementCost' },
  { name: FINANICAL_LEVERS.PROMOTION_DAYS, value: 1, unit: "days", min: 0, max: 30, frozen: false, keyToAccessValue: 'Holidays', displayRange: true, payloadKey: 'holidays' },
];

function App() {
  const [duration, setDuration] = useState('Months');
  const [selectedDurationValue, setSelectedDurationValue] = useState(1);
  const [financeTarget, setFinanceTarget] = useState(20)
  const [data, setData] = useState(null);
  const [entities, setEntities] = useState([]);
  const [minimizeSidebar, setMinimizeSidebar] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [disableUpdateBtn, setDisableUpdateBtn] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', type: '' });
  const [isLeverChanged, setIsLeverChanged] = useState(false);
  const [updateFinancialLevers, setUpdateFinancialLevers] = useState(true);
  const [lineChartLoading, setLineChartLoading] = useState(false)
  const [leversLoading, setLeversLoading] = useState(false);
  const [onReset, setOnReset] = useState(false)

  const formatValue = (value) => {
    if (typeof value === 'number' && !Number.isInteger(value)) {
      // If the value is a decimal, apply toFixed() to round it to 2 decimal places
      return value.toFixed(2);
    }
    // For integers or non-number types, return the value as is
    return value;
  };

  // Function to show toast notifications
  const showToast = (message, type) => {
    setToast({ show: true, message, type });

    // Automatically close the toast after 3 seconds
    setTimeout(() => {
      setToast({ show: false, message: '', type: '' });
    }, 5000);
  };

  // useEffect(() => {
  //   handleFinancialLevers().then(() => {
  //     handleForecast(data)
  //   })
  // }, [])

  // useEffect(() => {
  //   // setDisableUpdateBtn(false);
  //   const fetchData = setTimeout(() => {
  //     setIsLoading(true);
  //     handleFinancialLevers().then((financialLeversData) => {
  //       setEntities(financialLeversData);
  //       setMinimizeSidebar(false);
  //       setData(null)
  //       return handleForecast(financialLeversData)
  //     }).then((forecastData) => {
  //       setData(forecastData)
  //     }).catch((error) => {
  //       showToast(`Something went wrong while fetching levers: ${error?.message}`, 'error');
  //     }).finally(() => {
  //       setIsLoading(false);
  //     })
  //   }, 1000)

  //   return () => clearTimeout(fetchData)

  // }, [duration, selectedDurationValue, financeTarget])


  // useEffect(() => {
  //   handleFinancialLevers()
  // }, [])

  // useEffect(() => {
  //   if (!onReset) {
  //     const timer = setTimeout(() => {
  //       handleFinancialLevers()
  //     }, 1000)
  //     return () => clearTimeout(timer)
  //   }
  // }, [duration, selectedDurationValue, financeTarget])

  useEffect(() => {
    if(entities?.length) {
      setUpdateFinancialLevers(true)
    }
    
  }, [duration, selectedDurationValue, financeTarget])

  const handleFinancialLevers = async () => {
    // return new Promise(async (resolve, reject) => {
    try {
      setOnReset(false)
      setMinimizeSidebar(false);
      
      // setUpdateFinancialLevers(false);
      let financialEntities = entities;
      // if(!isLeverChanged) {
      if(updateFinancialLevers) {
        setLeversLoading(true);
        const financialLevers = (await FinanceForecastApi.fetchFinancialLevers({ selected: duration, duration: selectedDurationValue, target: financeTarget, })).data;
        financialEntities = initialEntities
        financialEntities?.forEach((item, index) => {
          financialEntities[index]['value'] = formatValue(financialLevers[financialEntities[index]['keyToAccessValue']])
          financialEntities[index]['frozen'] = false;
        })
        setLeversLoading(false);
        setUpdateFinancialLevers(false);
      }
      
      // setIsLoading(false);

      setEntities(financialEntities);
      setLineChartLoading(true);
      let payload = {};
      financialEntities?.forEach((item) => {
        item['value'] = Number(item['value'])
        payload[item?.payloadKey] = item?.value
      })
      const forecastData = (await FinanceForecastApi.predict({ selected: duration, duration: selectedDurationValue, target: financeTarget, ...payload })).data;
      setData(forecastData)
      // setIsLeverChanged(false)
      // }

      // let payload = {};
      // financialEntities?.forEach((item) => {
      //   item['value'] = Number(item['value'])
      //   payload[item?.payloadKey] = item?.value
      // })
      // const forecastData = (await FinanceForecastApi.predict({ selected: duration, duration: selectedDurationValue, target: financeTarget, ...payload })).data;
      // setData(forecastData)
      // setDisableUpdateBtn(true);
      // setData(null)
      // resolve(financialEntities)
    } catch (error) {
      console.log('Something went wrong', error)

      // showToast(`Something went wrong: ${error?.message}`, 'error');
      // reject(error)
    } finally {
      setLeversLoading(false);
      setLineChartLoading(false);
    }
    // })

  }

  const handleForecast = async (financialLevers = []) => {
    try {
      setOnReset(false)
      setLineChartLoading(true);
      let payload = {};
      financialLevers?.forEach((item) => {
        item['value'] = Number(item['value'])
        payload[item?.payloadKey] = item?.value
      })
      const forecastData = (await FinanceForecastApi.predict({ selected: duration, duration: selectedDurationValue, target: financeTarget, ...payload })).data;
      setData(forecastData)
      // resolve(forecastData)
    } catch (error) {
      console.log('Something went wrong', error)
      // showToast(`Something went wrong while fetching forecast: ${error?.message}`, 'error');
      // reject(error)
    } finally {
      setLineChartLoading(false);
    }
  }

  //   useEffect(() => {
  //   // setDisableUpdateBtn(false);
  //   if(entities?.length && updateFinancialLevers) {
  //     const fetchData = setTimeout(async () => {
  //       try {
  //         setLineChartLoading(true);
  //         let payload = {};
  //         entities?.forEach((item) => {
  //           item['value'] = Number(item['value'])
  //           payload[item?.payloadKey] = item?.value
  //         })
  //         const forecastData = (await FinanceForecastApi.predict({ selected: duration, duration: selectedDurationValue, target: financeTarget, ...payload })).data;
  //         setData(forecastData)
  //         // resolve(forecastData)
  //       } catch (error) {
  //         console.log('Something went wrong', error)
  //         // reject(error)
  //       } finally {
  //         setLineChartLoading(false);
  //       }
  //     }, 1000)

  //     return () => clearTimeout(fetchData)
  //   }

  // }, [entities, updateFinancialLevers])


  const generateForecast = async (financialLevers = []) => {
    // return new Promise(async (resolve, reject) => {

    try {
      setIsLoading(true);
      let payload = {};
      financialLevers?.forEach((item) => {
        item['value'] = Number(item['value'])
        payload[item?.payloadKey] = item?.value
      })
      const forecastData = (await FinanceForecastApi.predict({ selected: duration, duration: selectedDurationValue, target: financeTarget, ...payload })).data;
      setData(forecastData)
      // resolve(forecastData)
    } catch (error) {
      console.log('Something went wrong', error)
      // reject(error)
    } finally {
      setIsLoading(false);
    }

    // })
  };
  const debounce = (fn, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn(...args);
      }, delay)
    }
  }

  // const handleForecast = (financialLevers = []) => {
  //   debounce(generateForecast, 2000, [financialLevers])
  // }

  const reset = () => {
    setOnReset(true);
    setData(null)
    setEntities([]);
    setDuration('Months')
    setSelectedDurationValue(1)
    setFinanceTarget(20)
    setDisableUpdateBtn(false)
    // setMinimizeSidebar(true)
  }

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <div className="flex h-screen ">
        <Sidebar
          duration={duration}
          minimize={minimizeSidebar}
          setMinimizeSidebar={setMinimizeSidebar}
          // setDuration={setDuration}
          // selectedValue={selectedValue}
          // setSelectedValue={setSelectedValue}
          handleForecast={handleFinancialLevers}
          handleFinancialLevers={handleFinancialLevers}
          entities={entities}
          setEntities={setEntities}
          leversLoading={leversLoading}
          setIsLeverChanged={setIsLeverChanged}

          setDuration={setDuration}
          selectedDurationValue={selectedDurationValue}
          setSelectedDurationValue={setSelectedDurationValue}
          financeTarget={financeTarget}
          setFinanceTarget={setFinanceTarget}
          disableUpdateBtn={disableUpdateBtn}
          onReset={reset}
        />


        {/* Graph/Results Section */}
        <div className="flex-1 flex flex-col overflow-auto ">
          {/* Toolbar Section */}
          {/* <Toolbar
            duration={duration}
            setDuration={setDuration}
            selectedDurationValue={selectedDurationValue}
            setSelectedDurationValue={setSelectedDurationValue}
            financeTarget={financeTarget}
            setFinanceTarget={setFinanceTarget}
            handleForecast={handleFinancialLevers}
            entities={entities}
            setEntities={setEntities}
            disableUpdateBtn={disableUpdateBtn}
            onReset={reset}
          /> */}
          <GraphContainer data={data} lineChartLoading={lineChartLoading} />
          {/* <BarChartContainer /> */}
        </div>
      </div>
      {/* Conditionally render the toast if it's visible */}
      {toast.show && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ show: false, message: '', type: '' })}
        />
      )}

      <ToastContainer />
    </>

  );
}

export default App;